import { useEffect, useRef } from "react";
import axios from "axios";
import { trackPurchase } from "@/utils/tracking";

export function confirmedPurchase(order) {
  const orderId = order?.id || order?.order_id;
  if (!orderId || typeof order.total !== "number" || !Number.isFinite(order.total) || order.total < 0) return null;
  if (["awaiting_payment", "pending_verification", "cancelled", "canceled", "refunded"].includes(order.status)) return null;
  if (order.payment_status && order.payment_status !== "paid") return null;
  // An accepted cash order has an operational status but no payment_status.
  if (order.payment_status !== "paid" && !["pending", "confirmed", "preparing", "ready", "delivering", "delivered", "completed"].includes(order.status)) return null;
  return { orderId, eventId: `order_${orderId}`, value: order.total };
}

export function usePurchaseTracking({ order, restaurant, pixelReady, API }) {
  const sent = useRef(new Set());
  useEffect(() => {
    const purchase = confirmedPurchase(order);
    if (!purchase || !restaurant?.id || !pixelReady || typeof window.fbq !== "function") return;
    if (order.restaurant_id && order.restaurant_id !== restaurant.id) return;
    const key = `${restaurant.id}:${purchase.eventId}`;
    if (sent.current.has(key)) return;
    const { eventId, orderId, value } = purchase;
    sent.current.add(key);
    // Unified tracking owns the single browser Purchase and its shared CAPI ID.
    trackPurchase({ cart_value: value, metadata: {
      event_id: eventId, order_id: orderId, currency: restaurant.currency || "EUR",
    } });
    // Browser audit means queued in fbq, not proof of receipt by Meta.
    axios.post(`${API}/carol/${restaurant.id}/pixel-log`, {
      event_name: "Purchase", event_id: eventId, order_id: orderId, value,
    }).catch(() => {});
  }, [order, restaurant?.id, restaurant?.currency, pixelReady, API]);
}

